<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <CardForm
      :formShow="formShow"
      :formShowAt="formShowAt"
      :formAction="formAction"
      :card="card"
      :cardInit="cardInit"
      @isCardDataChange="handleCardFormDataChange"
      @formActionCompleted="handleCardFormActionCompleted"
      @onReset="handleCardFormReset"
    />
  </v-navigation-drawer>
</template>

<script>
// @ is an alias to /src
import CardForm from '@/components/CardForm.vue'

export default {
  components: {
    CardForm,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formShowAt: {
      type: String,
      default: '',
    },
    formAction: {
      type: String,
      default: '',
    },
    card: {
      type: Object,
      required: true,
    },
    cardInit: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleCardFormDataChange(value) {
      this.$emit('isCardDataChange', value)
    },
    handleCardFormActionCompleted(value) {
      this.$emit('formActionCompleted', value)
    },
    handleCardFormReset(value) {
      this.$emit('onReset', value)
    },
  },
}
</script>
